import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class GraySlab extends Floor {
	static key = "GraySlab";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): GraySlab {
		const f = new GraySlab(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
